// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"app-components-cookiebar--wrapper","text":"app-components-cookiebar--text","button":"app-components-cookiebar--button"};